/* eslint-disable no-nested-ternary */
import React from 'react';
import Link from 'next/link';
import { CloseIcon, LogoutIcon, MenuIcon } from '@avila-tek/ui/src';
import { useMutation } from '@apollo/client';
import { signOut } from 'next-auth/react';
import { routes } from '../../../routes';
import { SIGN_OUT } from '../../../graphql/mutation';
import { useNotify, useUser } from '../../../hooks';
import { roles } from '../../../static';
import SidebarItem from './SidebarItem';
import UserPhoto from '../UserPhoto';

function Sidebar() {
  const notify = useNotify();
  const [user] = useUser();
  const [isCollapse, setIsCollapse] = React.useState(false);

  const [signOutMutation] = useMutation<{
    signOut: {
      success: boolean;
    };
  }>(SIGN_OUT);

  const bgColor =
    user?.userType === roles.admin ? 'bg-gray-300' : 'bg-purple-300';

  const textColor =
    user?.userType === roles.admin
      ? 'text-neutral-warm-500 hover:text-turquoise-300'
      : 'text-purple-100 hover:text-white';

  const title = {
    [roles.admin]: 'Administrador',
    [roles.company]: 'Empresa',
    [roles.ally]: 'Aliado',
  };

  const handleSignOut = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    try {
      e.preventDefault();
      signOutMutation();
      signOut({ callbackUrl: `/sign-in/${user?.userType}` });
      localStorage.removeItem('x-token');
    } catch (error) {
      notify(error.message, 'error');
    }
  };

  return (
    <nav
      className={`${bgColor} md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden border-0  flex flex-wrap items-center justify-between relative md:w-72 z-50 w-full`}
    >
      <div
        className={` flex-col md:items-stretch overflow-hidden md:min-h-full md:flex-nowrap px-0 flex items-center justify-between w-full md:pt-8`}
      >
        <div className="w-full flex items-center h-[90px]">
          {/* MenuBtn to collapse, only mobile  */}
          <button
            className="cursor-pointertext-text-white opacity-50 md:hidden px-3 text-xl leading-none "
            type="button"
            onClick={(e) => {
              e.preventDefault();
              setIsCollapse(!isCollapse);
            }}
          >
            <span className="block w-6 h-6  text-text-white ">
              {isCollapse ? <CloseIcon /> : <MenuIcon />}
            </span>
          </button>
          {/* Logo */}
          <div className="flex justify-between mx-auto ">
            <Link href="/">
              <div className="md:block md:my-8 md:mx-auto my-4 overflow-hidden flex flex-col  ">
                <img
                  className="h-[60px] overflow-hidden "
                  alt="logo"
                  src="/logos/logo-white.png"
                />
                <div className="hidden md:block w-full text-center">
                  <span
                    className={`text-sm uppercase ${
                      user?.userType !== roles.admin
                        ? 'text-purple-100'
                        : 'text-neutral-warm-500'
                    }`}
                  >
                    {title[user?.userType]}
                  </span>
                </div>
              </div>
            </Link>
          </div>
          {/* user */}
          <UserPhoto className="flex md:hidden justify-between  md:mx-0" />
        </div>
        <div
          className={`w-full md:flex md:flex-col md:justify-between md:items-stretch overflow-y-auto overflow-x-hidden h-auto flex-1
            ${isCollapse ? 'block' : 'hidden'}
              `}
        >
          {/* routes */}

          <ul className="w-full flex flex-col pl-0 mb-0 list-none">
            {routes.map((route) =>
              route.privileges?.includes(user?.userType) && route.show ? (
                <SidebarItem key={route.text} {...route} />
              ) : null
            )}
          </ul>
          {/* logout btn */}
          <button
            type="button"
            onClick={handleSignOut}
            className={`${textColor} w-fit mx-auto my-6  font-medium flex items-center space-x-3 `}
          >
            <LogoutIcon className="w-4 h-4 " />
            <span className="overflow-hidden text-clip whitespace-nowrap">
              Cerrar sesión
            </span>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Sidebar;
